import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

import DevuelveMateriasDocente from '../Docentes/DevuelveMateriasDocente';
import DocenteBuscadorActivo from './DocenteBuscadorActivo';
import ObtieneDatosCookies from '../obtieneDatosCookiesUsuario';
import comprueboPermisos from '../tools/comprueboPermisos';

function Main() {
  const Usuario = ObtieneDatosCookies();
  const [consulta, setConsulta] = useState("");
  const [estadoComoDocente, setEstadoComoDocente] = useState(false);
  const [datosDocente, setDatosDocente] = useState(null);
  const [cargando, setCargando] = useState(false);
  const navigate = useNavigate();

  // Protección de acceso
  useEffect(() => {
    if (!Usuario.id || !comprueboPermisos(Usuario.funcion, "Busco Docentes")) {
      alert("Acceso no Autorizado");
      window.location.href = './Docentes';
    }
  }, []);

  const obtieneDocencia = async (dni) => {
    try {
      setCargando(true);
      setDatosDocente(null);  // Limpiar estado previo
      setEstadoComoDocente(false);

      const username = "nocapinyass";
      const password = process.env.REACT_APP_PASS;
      const token = btoa(`${username}:${password}`);

      const response = await axios.post(
        `https://wwwa.isepsantafe.net.ar/expedientes/docentes/devuelveDocente/${dni}`,
        { estado: "activo" },
        {
          headers: { Authorization: `Basic ${token}` },
        }
      );

      if (response?.data) {
        if (response.data.DatosMaterias?.length > 0) {
          setEstadoComoDocente(true);
          setDatosDocente(response.data);
        } else {
          setEstadoComoDocente(false);
          setDatosDocente({ docente: [] }); // Para mostrar mensaje de "no encontrado"
        }
      }
    } catch (error) {
      console.error("Error obteniendo docencia:", error);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    if (consulta) {
      obtieneDocencia(consulta);
    }
  }, [consulta]);

  return (
    <div style={{ margin: "10px", textAlign: "center" }}>
      <h4>BUSCADOR DOCENTE</h4>

      <div style={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
        <DocenteBuscadorActivo
          devuelvo={(s) => {
            setConsulta(s.docenteDni); // Refresca todo
          }}
        />
        <button className='btn btn-warning mt-2' onClick={() => navigate('/Docentes')}>Volver</button>
      </div>

      {cargando && <p className="mt-4">🔄 Cargando datos del docente...</p>}

      {!cargando && datosDocente && (
        <>
          {datosDocente?.docente?.length > 0 ? (
            <h2>
              Docente: {datosDocente.docente[0].docenteApellido},{" "}
              {datosDocente.docente[0].docenteNombres} ({datosDocente.docente[0].docenteTipo})
            </h2>
          ) : (
            <h2>Docente sin horas</h2>
          )}

          <hr />
          {estadoComoDocente && <DevuelveMateriasDocente datos={datosDocente} />}
          <div style={{ padding: "15px" }}></div>
        </>
      )}
    </div>
  );
}

export default Main;
